import { PaStatus } from "../../../../enums/paStatus";

/**
 * Derives the Astera submission comment shown in the Submit Onco modal and table.
 *
 * @input data - Table row or order record (camelCase or snake_case fields)
 * @return Comment text derived from PA outcome fields, or empty when none apply
 */
export const getAsteraSubmissionDisplayComment = (
  data: Record<string, unknown>,
): string => {
  const responseStatus = String(
    data.responseStatusValue ?? data.response_status ?? PaStatus.PENDING,
  );

  if (responseStatus === PaStatus.APPROVED) {
    const authExpiration = data.pa_outcome_auth_expiration;
    if (authExpiration) {
      return `Till ${String(authExpiration)}`;
    }
  } else if (responseStatus === PaStatus.DENIED) {
    const providerSummary = data.pa_outcome_provider_summary;
    if (providerSummary) {
      return String(providerSummary);
    }
  }

  return "";
};
